import React from "react";

import style from "./devices.module.scss";
import { DevicesTable } from "./DevicesTable";

export const DeviceWrapper = (props) => {
  const { devices } = props;
  return (<div className={style["wrapper"]}>
    <DevicesTable devices={devices} />
  </div>);
};
